import SendbirdProvider from '@sendbird/uikit-react/SendbirdProvider'
import { isServer } from 'lib/nextjs'
import { useStore } from 'lib/store/useStore'
import { globalCss, theme } from 'lib/theme'
import { observer } from 'mobx-react-lite'
import {
  textBody2Css,
  textBody3Css,
  textBody4Css,
  textCaption1Css,
  textCaption2Css,
  textCaption3Css,
} from 'primitives/Text'

const globalStyles = globalCss({
  '--sendbird-font-family-default': { fontFamily: theme.fonts.primary },
  '.sendbird-modal,.sendbird-dropdown__reaction-bar': {
    zIndex: '$modal',
  },
  '.sendbird-theme--dark': {
    '.sendbird-label--subtitle-2': { textBody2Css, lineHeight: '16px' },
    '.sendbird-label--body-1': textBody3Css,
    '.sendbird-label--body-2': textBody4Css,
    '.sendbird-label--caption-1': textCaption1Css,
    '.sendbird-label--caption-2': textCaption2Css,
    '.sendbird-label--caption-3': textCaption3Css,
  },
  // Some weird empty div in the dom, gets rendered by the ChannelListProvider if it contains any children react nodes.
  '.sendbird-channel-list.undefined': { display: 'none' },
})

const SBcolorSet = {
  '--sendbird-dark-primary-500': theme.colors.voilet100.toString(),
  '--sendbird-dark-primary-400': theme.colors.voilet100.toString(),
  '--sendbird-dark-primary-300': theme.colors.voilet100.toString(),
  '--sendbird-dark-primary-200': theme.colors.voilet100.toString(),
  '--sendbird-dark-primary-100': theme.colors.voilet100.toString(),
  '--sendbird-dark-ondark-03': theme.colors.gray800.toString(),
  '--sendbird-dark-ondark-04': theme.colors.gray500.toString(),
  '--sendbird-dark-onlight-01': theme.colors.gray900.toString(),
}

const _SbProvider: React.FC = ({ children }) => {
  const { user } = useStore()

  if (isServer() || !user.isLoggedIn) return <>{children}</>

  globalStyles()

  return (
    <SendbirdProvider
      appId={process.env.NEXT_PUBLIC_SB_APP_ID ?? ''}
      userId={user.profileId ?? ''}
      nickname={user.name}
      theme='dark'
      colorSet={SBcolorSet}
    >
      {children}
    </SendbirdProvider>
  )
}

export const SbProvider = observer(_SbProvider)
